import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";
import { logoutUser } from "../slices/auth/login/thunk";
import { useAuth } from "../Provider/AuthProvider";

const AuthProtected = (props: any) => {
    const dispatch: any = useDispatch();
    const { user, allowedInterfaces } = useAuth();

    useEffect(() => {
        if (user) {
            setAuthorization(user.token);
        } else if (!user?.token) {
            dispatch(logoutUser());
        }
    }, [user, dispatch]);

    if (!user?.token) {
        return <Navigate to="/login" replace />;
    }

    return <>{props.children}</>;
};

export default AuthProtected;